import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';

import { Loader } from '@app-evolution-cms/element-ui';
import { ROUTE } from '@app-evolution-cms/router';

import { AuthProvider } from '../app/providers/auth';
import { ThemeProvider } from '../theme-provider';
import { DataLakeMetadataProvider } from './rules/_providers/data-lake-metadata-provider';
import { UserPreferencesProvider } from './user-preferences/_providers/user-preferences-provider';
import { PermissionsProvider } from './users/_providers/permissions-provider';

import { InactivityDetector } from '../app/components/inactivity-detector';
import { Navigation } from './navigation';

import { NOTIFICATION_CENTER_TEMPLATES_ROUTES } from './bucket/routes';
import { DASHBOARD_ROUTES } from './dashboard/routes';
import { FAQS_ROUTES } from './faqs/routes';
import { MEDIA_ROUTES } from './media/routes';
import { MODULES_CONTENT_ROUTES } from './modules-content/routes';
import { MODULES_ROUTES } from './modules/routes';
import { NOT_FOUND_ROUTES } from './not-found/routes';
import { ONBOARDING_SPLASH_ROUTES } from './onboarding-splash/routes';
import { RULES_ROUTES } from './rules/routes';
import { TARGET_GROUPS_ROUTES } from './target-groups/routes';

const router = createBrowserRouter([
  {
    path: ROUTE.root,
    hydrateFallbackElement: <Loader />,
    element: (
      <AuthProvider>
        <PermissionsProvider>
          <DataLakeMetadataProvider>
            <ThemeProvider>
              <UserPreferencesProvider>
                <InactivityDetector />
                <Outlet />
              </UserPreferencesProvider>
            </ThemeProvider>
          </DataLakeMetadataProvider>
        </PermissionsProvider>
      </AuthProvider>
    ),
    children: [
      {
        path: ROUTE.root,
        element: <Navigation />,
        children: [
          DASHBOARD_ROUTES,
          FAQS_ROUTES,
          MEDIA_ROUTES,
          MODULES_CONTENT_ROUTES,
          MODULES_ROUTES,
          NOTIFICATION_CENTER_TEMPLATES_ROUTES,
          ONBOARDING_SPLASH_ROUTES,
          RULES_ROUTES,
          TARGET_GROUPS_ROUTES,
        ],
      },
      NOT_FOUND_ROUTES,
    ],
  },
]);

export default function Routes() {
  return <RouterProvider router={router} />;
}
